// extracted by mini-css-extract-plugin
export default {"pageTabs":"NavBar_pageTabs__gtxeq","pageTab":"NavBar_pageTab__psW45","pageTab_active":"NavBar_pageTab_active__kKkhX","pageTab_inactive":"NavBar_pageTab_inactive__2EI+D"};